import { Box, Grid } from "@mui/material";
import SaleTable from "../../components/Fleet/SaleTable/SaleTable";
import SalePopup from "../../components/Fleet/SalePopup/SalePopup";

const SalePage = () => {
  return (
    <Box className="driver-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "800px" }}
            >
              <Grid item>
                <SalePopup />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <SaleTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SalePage;
